import { useState } from "react";
import { PasswordGate } from "../components/PasswordGate";
import { Hero } from "../components/Hero";
import { Welcome } from "../components/Welcome";
import { FullImage } from "../components/FullImage";
import { Schedule } from "../components/Schedule";
import { Accommodation } from "../components/Accommodation";
import { Transportation } from "../components/Transportation";
import { PracticalInfo } from "../components/PracticalInfo";
import { RsvpForm } from "../components/RsvpForm";
import { Footer } from "../components/Footer";
import { MusicPlayer } from "../components/MusicPlayer";

export default function Invitation() {
  const [unlocked, setUnlocked] = useState(
    localStorage.getItem("site_unlocked") === "true"
  );

  if (!unlocked) {
    return <PasswordGate onUnlock={() => setUnlocked(true)} />;
  }

  return (
    <div className="min-h-screen bg-[#F2EDE3]" data-testid="invitation-page">
      <Hero />
      <Welcome />
      <FullImage
        src="/photos/harbour-sunset.jpg"
        alt="Sandhamn harbour at sunset"
        testid="fullimage-sandhamn"
      />
      <Schedule />
      <Accommodation />
      <FullImage
        src="/photos/seglarhotellet-night.jpg"
        alt="Seglarhotellet in the evening"
        testid="fullimage-hotel-night"
      />
      <Transportation />
      <FullImage
        src="/photos/norrskar.jpg"
        alt="M/S Norrskär in the archipelago"
        testid="fullimage-norrskar"
      />
      <PracticalInfo />
      <RsvpForm />
      <Footer />
      <MusicPlayer />
    </div>
  );
}
